import { styled } from '@mui/material';

interface PoppedProps {
  isPopped?: boolean;
}

export const DrawerContentWrapper = styled('div')<PoppedProps>(({ theme, isPopped }) => ({
  paddingLeft: isPopped ? theme.spacing(2) : '5rem',
  flex: 1,
  ...(isPopped && {
    paddingTop: '2.5rem',
    height: '100%',
  }),
}));

export const DrawerHeader = styled('div')<PoppedProps>(({ isPopped }) => ({
  position: isPopped ? 'fixed' : 'sticky',
  top: 0,
  left: isPopped ? 0 : undefined,
  zIndex: 1000,
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  height: '2rem',
  borderBottom: '1px solid #BDC4CB',
  minWidth: 0,
}));

export const DrawerHeaderContent = styled('div')<PoppedProps>(({ theme, isPopped }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flex: 1,
  paddingLeft: isPopped ? theme.spacing(2) : '5rem',
  minWidth: 0,
  overflowX: 'auto',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  ...(!isPopped && {
    '@media (max-width: 768px)': {
      paddingLeft: '3rem',
    },
    '@media (max-width: 480px)': {
      paddingLeft: '1rem',
    },
  }),
}));

export const DrawerSizeBar = styled('div')({
  height: '3px',
  cursor: 'row-resize',
  backgroundColor: '#ccc',
});
